module.exports = __webpack_public_path__ + "static/img/gongsishouye_05.3058e00c.jpg";